export default __webpack_public_path__ + "static/media/rosary_image.bda2b482.svg";